app.controller(
    'UserListController', ['$scope', '$compile', 'Datatable', 'Configuration', 'UserService', UserListController]
);

function UserListController($scope, $compile, Datatable, Configuration, UserService) {

    $scope.$on(
        '$viewContentLoaded', function () {
            $scope.datatable = $('.user-list').DataTable(
                {
                    processing : true,
                    serverSide : true,
                    ajax : {
                        url : Configuration.api.url + '/user/datatable',
                        type : 'POST',
                        dataFilter : function (data) {
                            var json = jQuery.parseJSON(data);

                            json.recordsTotal = json.result.count;
                            json.recordsFiltered = json.result.count;
                            json.data = json.result.rows;

                            return JSON.stringify(json);
                        },
                        beforeSend : function (request) {
                            request.setRequestHeader("X-API-TOKEN", UserService.getToken());
                        },
                        error : $scope.datatableAjaxErrorHandler
                    },
                    order : [[1, 'asc']],
                    columns : [
                        {
                            data : 'pathToPhoto',
                            sortable : false,
                            render : function (data, type, full, meta) {
                                if (data && data != '') {
                                    return '<img class="vignette" src="' + Configuration.assets.url + data + '" />';
                                } else {
                                    return 'Aucune';
                                }
                            }
                        },
                        { data : 'lastName' },
                        { data : 'firstName' },
                        { data : 'phone' },
                        { data : 'email' },
                        {
                            data : 'role',
                            render : function (data, type, full, meta) {
                                if (data == 'ROLE_USER') {
                                    return 'Utilisateur';
                                } else if (data == 'ROLE_ADMIN') {
                                    return 'Administrateur';
                                } else {
                                    return data;
                                }
                            }
                        },
                        {
                            data : 'createdAt',
                            render : function (data, type, full, meta) {
                                return moment(data).format("DD/MM/YYYY HH:mm:ss");
                            }
                        },
                        {
                            data : 'status',
                            render : function (data, type, full, meta) {
                                if (data == 0) {
                                    return '<span class="label label-default">Inactif</span>';
                                } else if (data == 1) {
                                    return '<span class="label label-success">Actif</span>';
                                } else {
                                    return data;
                                }
                            }
                        },
                        {
                            data : 'id',
                            sortable : false,
                            render : function (data, type, full, meta) {
                                var editButton = '<a class="btn btn-primary btn-xs need-recompilation"' +
                                    ' ui-sref="app.user.edit({id : ' + data + '})">Modifier</a>';
                                var removeButton = '<a class="btn btn-danger btn-xs need-recompilation"' +
                                    ' data-url-start="user"' +
                                    ' data-id="' + data + '" ng-click="remove($event)">Supprimer</a>';

                                if (full.status === 1) {
                                    return editButton;
                                } else {
                                    return editButton + removeButton;
                                }
                            }
                        }
                    ],
                    drawCallback : function () {
                        $compile($('.user-list').find('.need-recompilation'))($scope);
                    },
                    language : Datatable.language
                }
            );
        }
    );

    /**
     * Callback on remove success event
     * launched by AppController.$scope.remove function
     * Reloads Datatable
     */
    $scope.$on(
        'removeSuccess', function (e) {
            $scope.datatable.ajax.reload();
        }
    );
}



